// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m0nR","content":"styles_content__1RyjA"};